import { message, Typography } from "antd";
import { FC, useContext } from "react";
import { MeetingLinksContext } from "../../../../app/context/MeetingLinksContext";
import { ConfirmButtons, Modal } from "../../../../ui";
import "./index.less";
import { reactiveLinksSelector, roundRobinDel, setSelRoundRobinMeetId } from "src/store/reactive-links-settings";
import { useDispatch, useSelector } from "react-redux";
import { removeLink } from "src/store/reactive-links-settings/asyncRequests";

interface DeleteMeetingLinkModalProps {
  onClose: () => void;
  isTeam?: boolean;
}

export const DeleteMeetingLinkModal: FC<DeleteMeetingLinkModalProps> = ({ onClose, isTeam }) => {
  const { deleteMeetingLink } = useContext(MeetingLinksContext);

  const { teamLinks, roundRobinMeetId } = useSelector(reactiveLinksSelector);
  const dispatch = useDispatch();
  const handleDeleteBtnClick = () => {
    if (isTeam) {
      dispatch(roundRobinDel(roundRobinMeetId));
      dispatch(removeLink({ linkId: roundRobinMeetId }));
      dispatch(setSelRoundRobinMeetId(null));
      message.success("Deleted round robin link");
      onClose();
    } else {
      deleteMeetingLink();
      onClose();
    }
  };

  return (
    <Modal open={true} title={"Are you sure you want to delete this meeting link?"} className={"delete-meeting-link-modal-root"} onCancel={onClose}>
      {/* <Typography.Paragraph className={"description"}>
        This will remove all associated data, and the process cannot be undone.
      </Typography.Paragraph> */}
      <ConfirmButtons leftButtonTitle={"Back"} rightButtonTitle={"Delete"} handleSubmit={handleDeleteBtnClick} onCancel={onClose} />
    </Modal>
  );
};
